import React from 'react';
import get from 'lodash/get';
import capitalize from 'lodash/capitalize';
import sortBy from 'lodash/sortBy';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { isEqual } from 'lodash/lang';

import Menu from '../../../../components/Menu';
import Button from '../../../../components/Button';
import Accordion from '../../../../components/Accordion';
import Modal from '../../../../components/Modal';
import ClosableModal from '../../../../components/Modal/ClosableModal';

import ProfileForm from '../editProfile/addProfileForm';
import { COLLEGE_PROFILE_TYPE_NAME_COLLEGE, COLLEGE_PROFILE_TYPE_NAME_SCHOOL } from '../../constants';
import * as actions from '../../actions';
import messages from '../../messages';
import '../../styles.css';

export class ProfilesDropdownComponent extends React.Component {
  static propTypes = {
    customProfiles: PropTypes.array,
    updateCustomProfiles: PropTypes.func.isRequired,
    onShowAddProfileModal: PropTypes.func.isRequired,
    removeCustomProfile: PropTypes.func.isRequired,
  };

  state = {
    activeAccordionIndex: -1,
    activeProfileIndex: -1,
    openModal: false,
    selectedProfile: null,
    showDeletionPopup: false,
  };

  onProfilesClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeAccordionIndex } = this.state;
    const newIndex = activeAccordionIndex === index ? -1 : index;

    this.setState({ activeAccordionIndex: newIndex });
  };

  openProfileForm = (profile) => {
    const { customProfiles } = this.props;
    const currentProfileIndexInState = customProfiles.findIndex((x) => isEqual(x, profile));
    this.setState({
      openModal: true,
      activeProfileIndex: currentProfileIndexInState,
      selectedProfile: customProfiles[currentProfileIndexInState],
    });
  };

  updateCustomProfile = (customProfile) => {
    const { activeProfileIndex } = this.state;

    if (activeProfileIndex !== -1) {
      this.props.updateCustomProfiles({ customProfile, updatedProfileIndex: activeProfileIndex });
    }
  };

  removeCustomProfile = () => {
    this.setState({ showDeletionPopup: true });
  }

  deleteCustomProfile = () => {
    const { activeProfileIndex } = this.state;
    if (activeProfileIndex !== -1) {
      this.props.removeCustomProfile(activeProfileIndex);
    }
  }

  _renderProfileForm = () => {
    const { selectedProfile, openModal, showDeletionPopup, activeProfileIndex } = this.state;
    return (
      <ClosableModal
        open={openModal}
        onClose={this.onCloseModal}
      >
        <ProfileForm
          onClose={this.onCloseModal}
          type={selectedProfile.type}
          profile={selectedProfile}
          profileIndex={activeProfileIndex}
          updateHubsCustomProfiles={this.updateCustomProfile}
          removeCustomProfile={this.removeCustomProfile}
        />
        {showDeletionPopup && (
          <Modal
            open={showDeletionPopup}
            styleName="deletion-popup-modal"
          >
            <React.Fragment>
              <Modal.Header styleName="deletion-popup-header">
                <FormattedMessage {...messages.profileDeletionConfirm} />
              </Modal.Header>
              <Modal.Actions>
                <Button id="deletion-popup-cancel-button" onClick={() => { this.setState({ showDeletionPopup: false }); }}>
                  <FormattedMessage {...messages.cancelDeletion} />
                </Button>
                <Button
                  id="deletion-popup-delete-button"
                  primary
                  onClick={() => {
                    this.deleteCustomProfile();
                    this.setState({ showDeletionPopup: false });
                    this.onCloseModal();
                  }}
                >
                  <FormattedMessage {...messages.deleteProfile} />
                </Button>
              </Modal.Actions>
            </React.Fragment>
          </Modal>
        )}
      </ClosableModal>
    );
  };

  onCloseModal = () => {
    this.setState({ openModal: false });
  };

  render() {
    const { activeAccordionIndex, selectedProfile, openModal } = this.state;
    const { customProfiles, onShowAddProfileModal } = this.props;
    const profiles = sortBy(customProfiles,
      ['type',
        (customProfile) => get(customProfile, 'program_name').toLowerCase(),
        (customProfile) => get(customProfile, 'persons_name').toLowerCase(),
      ])
      .filter((profile) => {
        const { type } = profile;
        return type && type !== COLLEGE_PROFILE_TYPE_NAME_COLLEGE && type !== COLLEGE_PROFILE_TYPE_NAME_SCHOOL;
      });

    const profilesList = profiles.map((profile) => {
      const { type } = profile;
      let profileSuffix;

      if (profile.program_name || profile.persons_name) {
        profileSuffix = (profile.program_name && type === 'program') ? ` - ${profile.program_name}` : ` - ${profile.persons_name}`;
      }

      return (
        <div key={profile.product_id}>
          <Link onClick={() => this.openProfileForm(profile)}> {/* eslint-disable-line jsx-a11y/anchor-is-valid */}
            {`${capitalize(type)} Spotlight`}{profileSuffix}
          </Link>
        </div>
      );
    });

    return (
      <Accordion as={Menu} fluid styleName="links-profiles-dropdown">
        <Menu.Item as="li" styleName="dropdown-menu-item">
          <Accordion.Title
            id="profiles-accordion-title"
            content="Spotlights"
            active={activeAccordionIndex === 0}
            index={0}
            onClick={this.onProfilesClick}
            styleName="profiles-links-accordion-title"
          />
          <Accordion.Content
            active={activeAccordionIndex === 0}
            content={(
              <div styleName="links-expanded-area">
                {profiles && profiles.length !== 0 ? (
                  <div id="profiles-list" styleName="profiles-list">
                    {profilesList && profilesList.length && profilesList}
                  </div>
                ) : (
                  <div styleName="no-profiles">
                    <span>
                      <FormattedMessage {...messages.noProfiles} />
                    </span>
                  </div>
                )}
                <Button onClick={onShowAddProfileModal} data-cy="Premium-Hem-Profiles-Create-Button">
                  <FormattedMessage {...messages.createNewProfile} />
                </Button>
              </div>
            )}
          />
        </Menu.Item>
        {selectedProfile && openModal && this._renderProfileForm()}
      </Accordion>
    );
  }
}

const mapStateToProps = (state) => ({
  customProfiles: get(state, 'nonPersistedCollegeProfile.linksAndProfiles.customProfiles'),
});

export default connect(mapStateToProps, { ...actions })(ProfilesDropdownComponent);
